import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	header: 'What currency would you like to send?',
	description:
		'Before you continue, please check the pre-selected currency is correct. If it’s not, you can choose what currency you’d like to send.',
	defaultCurrencyLabel: 'Set as default currency for payee',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
